export {MessageFlagsItem as default};

/**
* Message Flags Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageFlagsItem {
  /**
   * Defines if message was read
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  read = false;

  /**
   * Defines if message is flagged
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  flagged = false;

  /**
  * Defines if message was answered
  *
  * @public
  *
  * @type {Boolean}
  *
  * @since 7.0.0
  */
  answered = false;

  /**
   * Defines if message was forwarded
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  forwarded = false;

  /**
   * Defines if message is high priority
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  priority_high = false;

  /**
   * Defines if message is low priority
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  priority_low = false;
}